import { PlusIcon } from "@phosphor-icons/react";
import { PrimaryButton } from "./Form";

export default function LinkedSection({
  title,
  subtitle,
  count,
  canCreate,
  onCreate,
  addLabel = "Add",
  emptyTitle = "Nothing here yet",
  emptyDescription,
  "data-testid": testId,
  children,
}) {
  const isEmpty = count === 0;
  return (
    <section
      data-testid={testId}
      className="bg-white border border-slate-200 rounded-md shadow-card"
    >
      <header className="flex items-center justify-between gap-3 px-5 py-3.5 border-b border-slate-200">
        <div className="min-w-0">
          <div className="font-heading text-sm font-semibold text-slate-900">
            {title}
            {typeof count === "number" && (
              <span className="ml-2 text-[11px] text-slate-500 tabular font-normal">
                ({count})
              </span>
            )}
          </div>
          {subtitle && (
            <div className="text-[11px] text-slate-500 mt-0.5">
              {subtitle}
            </div>
          )}
        </div>
        {canCreate && (
          <PrimaryButton
            onClick={onCreate}
            data-testid={`${testId}-add-button`}
          >
            <PlusIcon size={14} weight="bold" /> {addLabel}
          </PrimaryButton>
        )}
      </header>
      {isEmpty ? (
        <div className="m-4 border border-dashed border-slate-200 rounded-md p-8 text-center bg-slate-50/40">
          <div className="font-heading text-sm font-semibold text-slate-900">
            {emptyTitle}
          </div>
          {emptyDescription && (
            <p className="text-xs text-slate-500 mt-1 max-w-sm mx-auto">
              {emptyDescription}
            </p>
          )}
        </div>
      ) : (
        children
      )}
    </section>
  );
}
